import * as React from "react";
type Props = {
  className?: string,
};
function SvgKidsSnacks2({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-kidsSnacks2"
      className={className}
    >
      <path
        d="M33.7596 8.27002H21.3496C20.2696 8.27002 19.3896 9.15002 19.3896 10.23L21.0796 30.52C21.0796 30.74 21.5196 30.97 21.5196 30.97C25.2096 33.05 29.4196 32.81 33.8596 30.97C33.8596 30.97 34.2996 30.73 34.2996 30.52L35.7296 10.23C35.7296 9.15002 34.8496 8.27002 33.7696 8.27002H33.7596Z"
        fill="#E5D1E5"
        stroke="currentColor"
        strokeWidth={0.9}
        strokeMiterlimit={10}
      />
      <path
        d="M26.6295 2H28.4795C29.9495 2 31.1495 3.2 31.1495 4.67V6.01C31.1495 6.12 31.0595 6.22 30.9395 6.22H24.1695C24.0595 6.22 23.9595 6.13 23.9595 6.01V4.67C23.9595 3.2 25.1595 2 26.6295 2Z"
        fill="#D2A7D2"
        stroke="currentColor"
        strokeWidth={0.9}
        strokeMiterlimit={10}
      />
      <path
        d="M29.0196 6.20996H26.0996V8.18996H29.0196V6.20996Z"
        fill="#D2A7D2"
        stroke="currentColor"
        strokeWidth={0.9}
        strokeMiterlimit={10}
      />
      <path
        d="M30.8995 13.2199C31.4795 13.6899 32.5595 14.6999 33.0995 16.3199C33.9295 18.7799 32.9695 20.9399 32.6195 21.6799C32.3095 22.3499 30.7895 25.3699 27.2295 26.4999C25.6495 26.9999 24.2695 26.9399 23.4695 26.8399C23.2995 26.8399 22.9695 26.7999 22.6695 26.5899C22.5795 26.5299 22.4395 26.4299 22.3495 26.2399C22.3195 26.1699 22.2295 25.9799 22.2795 25.7899C22.3395 25.5799 22.5295 25.4699 22.9295 25.2499C23.4495 24.9699 23.6995 24.8299 23.8295 24.7699C24.5395 24.4799 26.4495 23.1899 27.8495 21.2099C28.0395 20.9399 28.8695 19.7399 29.3995 17.9899C29.8795 16.3799 29.8795 15.0499 29.8395 14.4199C29.8195 14.0499 29.7895 13.7399 29.7495 13.5199C29.6695 13.4499 29.4595 13.2499 29.4395 12.9399C29.4395 12.8499 29.4195 12.6899 29.5295 12.5299C29.6695 12.3199 29.9595 12.1899 30.2195 12.2299C30.3795 12.2599 30.4795 12.3399 30.5495 12.3899C30.8695 12.6599 30.8895 13.0699 30.8895 13.2199H30.8995Z"
        fill="#F9EED8"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M27.7295 25.22C27.7295 25.22 31.7195 22.95 32.1595 19.27L27.7295 25.22Z"
        fill="#F9EED8"
      />
      <path
        d="M27.7295 25.22C27.7295 25.22 31.7195 22.95 32.1595 19.27"
        stroke="currentColor"
        strokeWidth={0.75}
      />
      <path
        d="M12.0897 11.4501L12.5097 11.5101C13.1397 11.6001 13.7497 11.6801 14.3897 11.6101C15.2797 11.5101 16.4197 10.7401 17.2897 11.2401C18.5497 11.9701 18.1997 14.5601 18.0497 15.7201C17.8697 17.1301 17.4497 18.3801 17.7597 19.8101C18.0197 21.0101 18.5097 22.1801 18.3097 23.4401C18.1497 24.4401 17.7897 25.2801 17.9197 26.3301C18.0397 27.3601 18.4097 28.3301 18.4697 29.3701V29.6001C18.5097 30.2701 18.4797 31.0901 18.0997 31.6301C17.4897 32.4801 16.2197 31.8101 15.4197 31.6901C13.2697 31.3501 11.2897 32.6201 9.12972 32.1901C7.79972 31.9201 7.90972 29.8101 8.04972 28.7401C8.21972 27.4401 8.56972 26.3001 8.32972 24.9701C8.14972 23.9701 8.03972 23.0801 8.19972 22.0701L8.26972 21.6101C8.46972 20.3301 8.62972 19.1301 8.35972 17.8201C8.08972 16.4801 7.55972 15.1501 7.72972 13.7601C7.86972 12.6201 8.38972 11.5201 9.56972 11.2701C10.3897 11.1001 11.2997 11.3301 12.1097 11.4501H12.0897Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M14.3901 25.3302C15.1801 25.1002 15.8701 24.1902 16.0901 23.4002C16.3101 22.6002 15.8801 21.5902 14.9501 21.9202C13.9101 22.2902 12.7601 25.7902 14.3901 25.3202V25.3302Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M12.3298 22.6998L12.3798 22.5499C12.5798 21.8299 12.6398 20.8698 11.9398 20.4498C11.5198 20.1998 10.6298 20.0398 10.2998 20.4998C9.62981 21.4698 11.6598 24.1498 12.3298 22.6998Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M15.9999 27.4101C16.4499 28.8601 13.5499 30.8601 13.1599 29.3101C12.9799 28.6001 13.4499 27.5901 13.9199 27.0901C14.4899 26.4801 15.7099 26.4601 16.0099 27.4101H15.9999Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M11.6997 16.3398C12.0897 16.6698 12.4297 17.5498 12.1697 18.0398C11.8697 18.5898 11.0497 18.3198 10.5597 18.1198L10.4497 18.0798C9.82974 17.8198 9.22974 17.3498 9.73974 16.6298C10.1597 16.0398 11.1297 15.8698 11.6897 16.3398H11.6997Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M16.2399 17.6C16.0999 18.26 15.6799 19.07 15.2999 19.61C14.8199 20.29 13.4199 20.56 13.5899 19.36C13.6899 18.62 14.1799 17.89 14.6999 17.37L14.7999 17.27C15.0499 17.03 15.3699 16.74 15.7399 16.8C16.1299 16.86 16.3299 17.21 16.2399 17.6Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M12.2301 26.8801C12.8001 26.2001 12.1401 25.2301 11.5301 24.9001C11.1301 24.6801 10.2101 24.4001 9.87013 24.8501C9.35013 25.5401 10.1201 26.2501 10.6401 26.6501L10.7801 26.7601C11.2301 27.0801 11.7801 27.4201 12.2201 26.8901L12.2301 26.8801Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M14.5899 14.2201C14.7799 14.7701 14.3599 15.9101 13.7699 16.0101C13.0899 16.1301 12.5599 15.3301 12.4099 14.7401C12.2699 14.1601 12.3099 13.0701 13.0799 13.0601C13.5699 13.0601 14.4199 13.7501 14.5899 14.2201Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M2.26993 31.2001C2.43993 30.5201 3.15993 30.2701 3.31993 30.2201C3.97993 30.0001 4.67993 30.1901 4.93993 30.3001C5.28993 30.4401 5.66993 30.7101 5.83993 31.2201C6.00993 31.7201 5.74993 32.1801 5.69993 32.2701C5.29993 32.9501 4.39993 33.0801 3.82993 33.0101C3.63993 32.9901 2.90993 32.9001 2.49993 32.2801C2.42993 32.1801 2.13993 31.7301 2.26993 31.2001Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M3.12988 31.4099C3.61988 32.1599 4.63988 30.7199 5.05988 31.6099L3.12988 31.4099Z"
        fill="#F0CA9E"
      />
      <path
        d="M3.12988 31.4099C3.61988 32.1599 4.63988 30.7199 5.05988 31.6099"
        stroke="currentColor"
        strokeWidth={0.75}
      />
      <path
        d="M3.47983 34.8198C3.96983 34.3198 4.72983 34.4698 4.88983 34.5098C5.56983 34.6498 6.07983 35.1698 6.24983 35.3898C6.47983 35.6898 6.67983 36.1098 6.55983 36.6398C6.44983 37.1598 5.98983 37.4198 5.90983 37.4698C5.21983 37.8498 4.37983 37.5098 3.91983 37.1598C3.76983 37.0398 3.18983 36.5998 3.13983 35.8598C3.13983 35.7398 3.11983 35.1798 3.49983 34.7898L3.47983 34.8198Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M4.10986 35.4399C4.15986 36.3299 5.75986 35.6099 5.67986 36.5899L4.10986 35.4399Z"
        fill="#F0CA9E"
      />
      <path
        d="M4.10986 35.4399C4.15986 36.3299 5.75986 35.6099 5.67986 36.5899"
        stroke="currentColor"
        strokeWidth={0.75}
      />
      <path
        d="M9.06002 36.89C9.04002 36.19 9.69002 35.76 9.82002 35.66C10.4 35.27 11.12 35.27 11.4 35.31C11.77 35.36 12.21 35.51 12.51 35.96C12.8 36.4 12.67 36.92 12.64 37.01C12.43 37.77 11.6 38.13 11.03 38.22C10.84 38.25 10.12 38.35 9.56002 37.86C9.47002 37.78 9.08002 37.44 9.06002 36.89Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeWidth={0.9}
      />
      <path
        d="M9.94971 36.8702C10.6197 37.4602 11.2197 35.8102 11.8697 36.5502L9.94971 36.8702Z"
        fill="#F0CA9E"
      />
      <path
        d="M9.94971 36.8702C10.6197 37.4602 11.2197 35.8102 11.8697 36.5502"
        stroke="currentColor"
        strokeWidth={0.75}
      />
      <path
        d="M18.4797 31.1598V33.8198L17.5597 32.8098L16.7997 33.6798L15.9197 32.7998L15.0697 33.6498L14.2397 32.8198L13.3697 33.6798L12.4897 32.7998L11.5697 33.7298L10.6497 32.8198L9.70969 33.7598L8.73969 32.7798L7.67969 33.8398V31.0098"
        fill="#C2DA96"
      />
      <path
        d="M18.4797 31.1598V33.8198L17.5597 32.8098L16.7997 33.6798L15.9197 32.7998L15.0697 33.6498L14.2397 32.8198L13.3697 33.6798L12.4897 32.7998L11.5697 33.7298L10.6497 32.8198L9.70969 33.7598L8.73969 32.7798L7.67969 33.8398V31.0098"
        stroke="#2E364E"
        strokeWidth={0.9}
        strokeLinejoin="round"
      />
      <path
        d="M17.9597 31.7798H8.18969C7.90969 31.7798 7.67969 31.5498 7.67969 31.2698V22.6298C7.67969 22.3598 7.91969 22.1598 8.17969 22.2098L10.4997 22.6298C12.0897 22.9198 13.7097 22.9298 15.2997 22.6598L17.9797 22.2098C18.2397 22.1698 18.4797 22.3698 18.4797 22.6298V31.2698C18.4797 31.5498 18.2497 31.7798 17.9697 31.7798H17.9597Z"
        fill="#C2DA96"
        stroke="#2E364E"
        strokeWidth={0.9}
      />
      <path
        d="M18.2597 23.9199C14.8597 24.4099 11.3697 24.4099 7.96969 23.9199C7.66969 23.9199 7.42969 23.7399 7.42969 23.5099V22.1099C7.42969 21.8999 7.67969 21.7399 7.95969 21.7799L10.3997 22.1099C12.0697 22.3399 13.7797 22.3399 15.4597 22.1299L18.2797 21.7699C18.5497 21.7399 18.7997 21.8899 18.7997 22.0999V23.4999C18.7997 23.7199 18.5597 23.9199 18.2597 23.9199Z"
        fill="#EDF4E0"
        stroke="#2E364E"
        strokeWidth={0.9}
      />
    </svg>
  );
}
export default SvgKidsSnacks2;
